import Vue from 'vue'
import commonLng from '@/locales/commonLng.json'
import popupLng from '@/locales/popupLng.json'
import pageLng from '@/locales/pageLng.json'
import { Check } from '@/utils/defines/Translation'
import en from '@/locales/_en.json'
import ghs from '@/locales/_ghs.json'

export const translation = {
	install(Vue) {
		Vue.prototype.tt = function (key, ...args) {
			let result = key
			if (Check.English) {
				if (
					popupLng[this.$options.name] &&
					popupLng[this.$options.name][key]
				) {
					result = popupLng[this.$options.name][key]
				}

				if (
					pageLng[this.$options.name] &&
					pageLng[this.$options.name][key]
				) {
					result = pageLng[this.$options.name][key]
				}

				if (commonLng[key]) {
					result = commonLng[key]
				}
				if (en[key]) {
					result = en[key]
				}
				if (ghs[key]) {
					result = ghs[key]
				}
			}
			for (let i = 0; i < args.length; i++) {
				result = result.replace(
					new RegExp('\\$\\{' + (i + 1) + '\\}', 'g'),
					args[i] 
				)
			}
			return result
		}
	},
}

export default translation
